import ReactDOM from "react-dom";
import "./index.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap-css-only/css/bootstrap.min.css";
import "mdbreact/dist/css/mdb.css";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "react-big-calendar/lib/css/react-big-calendar.css";
import * as serviceWorker from "./serviceWorker";
import { Router } from "react-router-dom";
import { createBrowserHistory } from "history";
import {
  ENDPOINT,
  ONLINE_ENDPOINT,
  isLocalHost,
  switchToOnline,
} from "./services/utilities";
import { Provider } from "react-redux";
import store from "./services/redux/store";
import { SessionEnded } from "./services/redux/slices/assets/persons/auth";
import axios from "axios";
import { ToastProvider } from "react-toast-notifications";
import App from "./App";
const customHistory = createBrowserHistory();

axios.defaults.baseURL = ENDPOINT;
axios.defaults.withCredentials = true;
// The sign-in token is an HttpOnly cookie. Browsers send cookies with requests
// from any site, so the server only accepts a cookie-signed change that carries
// this header, which other sites cannot add.
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

// local first: if the local server cannot be reached (no response at all), retry once on the online server
axios.interceptors.response.use(undefined, (error) => {
  const { config, response } = error || {};
  const usesLocalBase =
    !config?.url?.startsWith("http") && config?.baseURL !== ONLINE_ENDPOINT;

  if (
    !isLocalHost ||
    response ||
    axios.isCancel(error) ||
    !config ||
    config._onlineRetry ||
    !usesLocalBase
  )
    return Promise.reject(error);

  switchToOnline(axios);
  return axios({ ...config, baseURL: ONLINE_ENDPOINT, _onlineRetry: true });
});

// The server answers 403 "Access Expired" when a token is out of date or was
// revoked (the password changed). End the session so the sign-in modal opens,
// instead of leaving a page whose every request fails. Added after the
// retry above, so it sees the final answer of each request.
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const { status, data } = error?.response || {};
    const isSignIn = String(error?.config?.url || "").includes("/login");

    if (
      (status === 403 &&
        ["Access Expired", "Poorly Generated Token"].includes(data?.error)) ||
      // No session cookie any more (it lapsed, or was cleared).
      (status === 401 && data?.error === "Unauthorized" && !isSignIn)
    ) {
      store.dispatch(SessionEnded());
    }

    return Promise.reject(error);
  },
);

ReactDOM.render(
  <Router history={customHistory}>
    <Provider store={store}>
      <ToastProvider placement="top-center" autoDismiss={5000}>
        <App />
      </ToastProvider>
    </Provider>
  </Router>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.register();
